import {
  baseUniDriverFactory,
  countByHook,
  findByHook,
} from '../utils/test-utils/unidriver';
import { dataHooks } from './constants';

export const sidebarItemButtonNextDriverFactory = (base, body) => {
  const getPrefix = () => findByHook(base, dataHooks.prefix);
  const getSuffix = () => findByHook(base, dataHooks.suffix);

  return {
    ...baseUniDriverFactory(base, body),

    /**
     * Returns if the sidebar item is selected
     * @returns {Promise<boolean>}
     */
    isSelected: async () => (await base.attr('data-selected')) === 'true',

    /**
     * Returns if the sidebar item is disabled
     * @returns {Promise<boolean>}
     */
    isDisabled: async () => (await base.attr('data-disabled')) === 'true',

    /**
     * Returns if a suffix exists
     * @returns {Promise<boolean>}
     */
    suffixExists: async () => (await getSuffix()).exists(),

    /**
     * Returns count of suffix items
     * @returns {Promise<number>}
     */
    getSuffixCount: async () => countByHook(base, dataHooks.suffix),

    /**
     * Returns if a prefix exists
     * @returns {Promise<boolean>}
     */
    prefixExists: async () => (await getPrefix()).exists(),

    /**
     * Returns the skin
     * @returns {Promise<string>}
     */
    getSkin: async () => base.attr('data-skin'),

    /**
     * Returns the displayed text
     * @returns {Promise<string>}
     * */
    getText: async () => base.text(),
  };
};
